import { useQuery } from "@tanstack/react-query";
import { AddLinkModal } from "./product/AddLinkModal";
import { useAppModals } from "../hooks/useAppModals";
import { useLinkActions } from "../hooks/useLinkActions";
import { useAuth } from "../hooks/useAuth";
import { useInstallPrompt } from "../hooks/useInstallPrompt";
import { listContextGroups } from "../api/services";

/**
 * Global AddLinkModal - rendered at app level so it's available when
 * opening from share target (Instagram, browser) even on PaywallScreen.
 */
export const AddLinkModalGlobal = () => {
  const { isAuthenticated, isInitialized } = useAuth();
  const {
    isAddLinkModalOpen,
    sharedUrl,
    initialContextGroupId,
    closeAddLinkModal,
    clearSharedUrl,
    openInstallPrompt,
    hasShownInstallPrompt,
    markInstallPromptShown,
  } = useAppModals();
  const { shouldShowPrompt } = useInstallPrompt();

  const groupsQuery = useQuery({
    queryKey: ["groups", isAuthenticated],
    queryFn: async () => {
      const res = await listContextGroups();
      return res.data ?? [];
    },
    enabled: isInitialized,
  });
  const groups = groupsQuery.data ?? [];

  const { handleAddLink, createLinkMutation } = useLinkActions({
    onLinkCreated: () => {
      clearSharedUrl();
      closeAddLinkModal();
      if (shouldShowPrompt && !hasShownInstallPrompt) {
        markInstallPromptShown();
        setTimeout(() => openInstallPrompt(), 500);
      }
    },
  });

  return (
    <AddLinkModal
      isOpen={isAddLinkModalOpen}
      isLoading={createLinkMutation.isPending}
      initialUrl={sharedUrl}
      initialContextGroupId={initialContextGroupId}
      groups={groups}
      onClose={closeAddLinkModal}
      onSubmit={(url, contextGroupId) => handleAddLink(url, contextGroupId ?? undefined)}
    />
  );
};
